"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseStore = require("fluxible/addons/BaseStore");
class EntityStore extends BaseStore {
    constructor(dispatcher, type) {
        super(dispatcher);
        this.dispatcher = dispatcher;
        this.entities = new Array();
        this.singleEntity = new type();
    }
    handleEntities(payload) {
        this.entities = payload;
        this.emitChange();
    }
    handleEntity(payload) {
        this.singleEntity = payload;
        this.emitChange();
    }
    getEntities() {
        return this.entities;
    }
    getEntity() {
        return this.singleEntity;
    }
    dehydrate() {
        return {
            singleEntity: this.singleEntity,
            entities: this.entities,
        };
    }
    rehydrate(state) {
        this.singleEntity = state.singleEntity;
        this.entities = state.entities;
    }
}
exports.default = EntityStore;
